export function OutlineCheckIcon({
  width = 24,
  height = 24,
  fill = 'none',
  stroke = 'currentColor',
  strokeWidth = 2,
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20.535 7.005C20.535 7.515 20.345 8.025 19.955 8.415L10.305 18.065C9.525 18.845 8.255 18.845 7.475 18.065L6.055 16.645L3.585 14.175C2.805 13.395 2.805 12.135 3.585 11.355C3.975 10.965 4.495 10.765 5.005 10.765C5.515 10.765 6.025 10.965 6.415 11.355L8.885 13.815L17.125 5.585C17.905 4.805 19.175 4.805 19.955 5.585C20.345 5.975 20.535 6.485 20.535 7.005Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
